import { fDate } from "../utils/util";

export const DEPARTMENT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Department Master Id",
    },
    {
        dataIndex: "name",
        title: "Department Master Name",
    },
    {
        dataIndex: "orgName",
        title: "Organization Name",
    },
];

export const PROJECT_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Project Master Id",
    },
    {
        dataIndex: "name",
        title: "Project Master Name",
    },
    {
        dataIndex: "description",
        title: "Project Master Description",
    },
    {
        dataIndex: "departmentName",
        title: "Department Name",
    },
    {
        dataIndex: "orgName",
        title: "Organization Name",
    },
    {
        dataIndex: "sponsor",
        title: "Sponsor",
    },
    {
        dataIndex: "participatingOrganization",
        title: "Participating Organization",
    },
];

export const PROJECT_TYPE_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Project Type Master Id",
    },
    {
        dataIndex: "name",
        title: "Project Type Master Name",
    },
];

export const PHASE_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Phase Master Id",
    },
    {
        dataIndex: "name",
        title: "Phase Master Name",
    },
];

export const PROJECT_USER_MASTER_COLUMN = [
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "projectName",
        title: "Project Name",
    },
    {
        dataIndex: "userGroupName",
        title: "User Group",
    },
];

export const PROJECT_PHASE_ACTIVITY_COLUMN = [
    {
        dataIndex: "name",
        title: "Name",
    },
    {
        dataIndex: "activityDescription",
        title: "Activity Description",
    },
    {
        dataIndex: "projectCode",
        title: "Project Code",
    },
    {
        dataIndex: "activityCode",
        title: "Activity Code",
    },
    {
        dataIndex: "projectTypeName",
        title: "Project Type Name",
    },
    // {
    //     dataIndex: "phaseName",
    //     title: "Phase Name",
    // },    
    {
        dataIndex: "planStartDate",
        title: "Plan Start Date",
        render: (index: any, record: any) => {
            let formattedDate;
            if (record.planStartDate) {
                const inputDate = new Date(record?.planStartDate);
                formattedDate = fDate(inputDate);
            } else {
                formattedDate = "-"
            }
            return (
                <div className="d-flex align-items-start">
                    {formattedDate}
                </div>
            );
        },
    },
    {
        dataIndex: "planEndDate",
        title: "Plan End Date",
        render: (index: any, record: any) => {
            let formattedDate;
            if (record.planEndDate) {
                const inputDate = new Date(record?.planEndDate);
                formattedDate = fDate(inputDate);
            } else {
                formattedDate = "-"
            }
            return (
                <div className="d-flex align-items-start">
                    {formattedDate}
                </div>
            );
        },
    },
    {
        dataIndex: "expectedDeliverable",
        title: "Expected Deliverable",
    },
    {
        dataIndex: "issue",
        title: "Issue",
    },
    {
        dataIndex: "risk",
        title: "Risk",
    },
    {
        dataIndex: "issueOwner",
        title: "Issue Owner",
    },
    {
        dataIndex: "taskOwner",
        title: "Task Owner",
    },
    {
        dataIndex: "documentPath",
        title: "Document Path",
    },
    {
        dataIndex: "projectStatus",
        title: "Project Status",
    },
];

export const ORGANIZATION_MASTER_COLUMN = [
    {
        dataIndex: "id",
        title: "Organization Id",
    },
    {
        dataIndex: "name",
        title: "Organization Name",
    },
    {
        dataIndex: "code",
        title: "Organization Code",
    },
    {
        dataIndex: "contactPerson",
        title: "Contact Person",
    },
    {
        dataIndex: "contactEmail",
        title: "Contact Email",
    },
    {
        dataIndex: "contactPhone",
        title: "Contact Phone",
    },
    {
        dataIndex: "website",
        title: "Website",
    },
    {
        dataIndex: "city",
        title: "City",
    },
    {
        dataIndex: "state",
        title: "State",
    },
    {
        dataIndex: "country",
        title: "Country",
    },
    {
        dataIndex: "dependentOrgCode",
        title: "Dependent Organization Code",
    },
    {
        dataIndex: "organizationType",
        title: "Organization Type",
    },
];

export const PROJECTIVITY_STATUS = [
    {
        id: 0,
        name: "Completed",
    },
    {
        id: 1,
        name: "In Progress",
    },
    {
        id: 2,
        name: "On Hold",
    },
    {
        id: 3,
        name: "Open",
    },
];

export const KRA_MASTER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "KRA Master Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "KRA Name",
    },
];

export const TIME_SHEET_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Time sheet Id",
    },
    {
        key: "userName",
        dataIndex: "userName",
        title: "User Name",
    },
    {
        key: "totalWorkHours",
        dataIndex: "totalWorkHours",
        title: "Total Work Hours",
    },
];

export const USER_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Name",
    },
    {
        key: "mobileNo",
        dataIndex: "phoneNumber",
        title: "Mobile Number",
    },
    {
        key: "email",
        dataIndex: "email",
        title: "Email",
    },
    {
        key: "role",
        dataIndex: "userRole",
        title: "Subscriber",
    },
    {
        key: "group",
        dataIndex: "userGroup",
        title: "User Group",
    },
];

export const USER_ROLE_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "Subscriber Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "Subscriber Name",
    },
];

export const USER_GROUP_COLUMN = [
    {
        key: "id",
        dataIndex: "id",
        title: "User Group Id",
    },
    {
        key: "name",
        dataIndex: "name",
        title: "User Group Name",
    },
];